function deepClone<T>(object: T): T {
  if (window.structuredClone !== undefined) {
    return structuredClone(object);
  } else {
    return JSON.parse(JSON.stringify(object));
  }
}

export default deepClone;
